import React, { useState, useRef} from 'react';
//import ReCAPTCHA from 'react-google-recaptcha';
//import Turnstile from 'react-cloudflare-turnstile';
import HCaptchaManual from './HCaptchaManual';
import '../css/ContactForm.css';


function ContactForm() {
  const formRef = useRef(null);
  const [token, setToken] = useState('');
  const [captchaValido, setCaptchaValido] = useState(false);
  const [mensajeEnviado, setMensajeEnviado] = useState(false);

    const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaValido) {
      alert('Por favor, completa el CAPTCHA.');
      return;
    }

    const formData = new FormData(formRef.current);

    fetch('https://api.appsgsm.com/send', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) throw new Error('Error en el envío');
        return response.json();
      })
      .then((data) => {
        console.log('Mensaje enviado:', data);
        alert(data.message)
        setMensajeEnviado(true);
        formRef.current.reset();
        setCaptchaValido(false);
        setToken('');
        setTimeout(() => setMensajeEnviado(false), 5000);
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Ocurrió un error al enviar el mensaje.');
      });
  };

  return (
    <section className="contact-section" id="contacto">
      {/* <iframe name="hiddenFrame" style={{ display: 'none' }}></iframe> */}
      <h2 className="section-title">Contáctanos</h2>
      <div className="contact-container">
        {/* Logo a la izquierda */}
        <div className="contact-logo">
          <img src="/images/logoChilesSF.png" alt="Logo Salsas Gallegos" />
        </div>
        {/* Formulario a la derecha */}
       <form ref={formRef} onSubmit={handleSubmit} className='contact-form '>
        <input type="text" name="name" placeholder="Tu nombre" className='contact-form input'  />
        <input type="email" name="email" placeholder="Tu correo"  className='contact-form input' />
        <textarea name="message" placeholder="Tu mensaje" className='contact-form textarea' />

        {/* CAPTCHA de Cloudflare */}
         {/* <div class="cf-turnstile" data-sitekey="0x4AAAAAABlSakhZ-IxQGJEH"></div> */}

        <div style={{ width: '100%', height: '80px', marginTop: '15px' }}>
         
          {/* hCaptcha */}
       <HCaptchaManual
  sitekey="24e40238-edb0-4d80-be6c-9a06bf16baa6"
  onVerify={(token) => {
    setToken(token);
    setCaptchaValido(true);
  }}
  onExpire={() => setCaptchaValido(false)}
  onError={(err) => {
    console.error('hCaptcha error:', err);
    alert('Error con hCaptcha. Intenta recargar la página.');
  }}
/>
        </div>

        <button type="submit" className='contact-form estiloBoton'>Enviar</button>

        {/* {mensajeEnviado && <p  className="mensaje-confirmacion">✅ ¡Mensaje enviado exitosamente!</p>} */}

         
      </form>
      </div>

      <div>

      </div>
      
     <div className="logoIns-logo"> <p>Redes Sociales</p>
      <div className="social-icons">

      
     <a
          href="https://www.tiktok.com/@chileros.don.rene?_t=ZM-90uKkfV4LBA&_r=1"
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-link">
        
        <img
          src={require('../img/tok.png')}
          alt="Instagram"
          className="instagram-icon"
        />
      </a>


      <a
          href="https://www.instagram.com/chileros_don_rene"
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-link">
        
        <img
          src={require('../img/instagram.png')}
          alt="Instagram"
          className="instagram-icon"
        />



      </a>


      
       <a
          href="https://www.facebook.com/share/19drYwJvBU/"
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-link">
        
        <img
          src={require('../img/facebook.png')}
          alt="Instagram"
          className="instagram-icon"
        />


      </a>
      </div>
     </div>

    </section>
  );
}

export default ContactForm;
